import { Divider, Grid2, Paper, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useContext, useEffect, useState } from 'react';
import ElementCardButton from './ElementCardButton';
import { LanguageContext } from '../../contexts/LanguageContext';
import { globalBuilder } from '../../../archbuilder/GlobalBuilder';

interface ElementCardProps {
  title: string;
  isTitleLeft: boolean;
  attributes: ElementAttribute[];
  imageUrl?: string; // Prop para la imagen opcional
}

export class ElementAttribute {
  name: string = '';
  content: string = '';
  ref?: string = '';
  href?: string = '';
}

export const ElementCard = ({
  title,
  isTitleLeft,
  attributes,
  imageUrl,
}: ElementCardProps) => {
  const { language } = useContext(LanguageContext);
  const [activeContent, setActiveContent] = useState(attributes[0]?.content);
  const [activeRef, setActiveRef] = useState(attributes[0]?.ref);
  const [activeHref, setActiveHref] = useState(attributes[0]?.href);
  const [openIndex, setOpenIndex] = useState(0);

  const handleButtonClick = (
    content: string,
    ref: string | undefined,
    href: string | undefined,
    index: number,
  ) => {
    setActiveContent(content);
    setActiveRef(ref);
    setActiveHref(href);
    setOpenIndex(index);
  };

  useEffect(() => {
    setActiveContent(attributes[openIndex ?? 0]?.content);
    setActiveRef(attributes[openIndex ?? 0]?.ref);
    setActiveHref(attributes[openIndex ?? 0]?.href);
  }, [language]);

  const hasMultipleAttributes = attributes.length > 1;

  return globalBuilder.ElementCard(
    isTitleLeft,
    imageUrl ?? '',
    title,
    hasMultipleAttributes,
    handleButtonClick,
    attributes,
    openIndex,
    activeContent,
    activeRef ?? '',
    activeHref ?? '',
  );
};

export const formatText = (text: string) => {
  // Primero dividimos por saltos de línea y los procesamos
  const lines = text.split('\n');

  return lines.map((line, lineIndex) => {
    // Procesamos el formato (negrita/cursiva) para cada línea
    const parts = line.split(/(\*[^*]+\*|_[^_]+_)/g);
    const formattedLine = parts.map((part, partIndex) => {
      if (part.startsWith('*') && part.endsWith('*')) {
        return (
          <strong key={`${lineIndex}-${partIndex}`}>{part.slice(1, -1)}</strong>
        );
      } else if (part.startsWith('_') && part.endsWith('_')) {
        return <em key={`${lineIndex}-${partIndex}`}>{part.slice(1, -1)}</em>;
      }
      return <span key={`${lineIndex}-${partIndex}`}>{part}</span>;
    });

    // Retornamos la línea con un <br /> al final, excepto en la última línea
    return (
      <React.Fragment key={`line-${lineIndex}`}>
        {formattedLine}
        {lineIndex < lines.length - 1 && <br />}
      </React.Fragment>
    );
  });
};
